import type { SVGIconProps } from "@ch/components/Icons/SVGIcon";
import type { FC } from "react";

type ChevronRightIconProps = Partial<SVGIconProps>;

const ChevronRightFilledIcon: FC<ChevronRightIconProps> = (props) => (
  <svg
    fill="none"
    height={32}
    width={32}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      fill={props?.fill ?? "#4ABE82"}
      height={31}
      rx={15.5}
      width={31}
      x={0.5}
      y={0.5}
    />
    <rect
      height={31}
      rx={15.5}
      stroke={props?.stroke ?? "#4ABE82"}
      width={31}
      x={0.5}
      y={0.5}
    />
    <path
      d="m14.5 19.75 3-3.75-3-3.75"
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
  </svg>
);

export default ChevronRightFilledIcon;
